export interface GoogleOAuthArgs {
  provider: "google";
  options: { redirectTo: string };
}

// Google redirects back to our dedicated PKCE callback page, which owns the
// code-exchange (see src/ts/auth-callback.ts). Kept pure so it is unit-testable
// without importing the supabase client.
export function googleOAuthOptions(origin: string): GoogleOAuthArgs {
  return {
    provider: "google",
    options: { redirectTo: `${origin}/auth/callback/` },
  };
}
